import constant from "../../constant";
import axios from "axios";
import router from "../../router";
const api = constant.api + "payments";
// initial state
const state = () => ({
  all: [],
  payments: [],
  paymentSuppliers: [],
  payment: {},
});

// getters
const getters = {
  getAll: (state) => {
    return state.payments;
  },
  getPayment: (state) => {
    return state.payment;
  },

  getPayments: (state) => {
    return state.payments;
  },
  getPaymentSuppliers: (state) => {
    return state.payments;
  },

  getTotalAmount: (state) =>
    state.payments.reduce((acc, val) => acc + parseFloat(val.amount), 0),
};

// actions
const actions = {
  async getAll({ commit }) {
    await axios.get(api).then((response) => {
      let payments = response.data;
      commit("SET_PAYMENTS", payments);
      window.location;
    });
  },

  async show({ commit }, reference) {
    await axios.get(api + "/" + reference).then((response) => {
      let payment = response.data;
      commit("setPayment", payment);
    });
  },

  async store({ dispatch }, data) {
    await this.$api.create(api, data).then((response) => {
      let status = response.data.status;

      if (status == "success") {
        router.push({ name: "payments-customers-index" });
      }
    });
  },

  async update({ dispatch }, data) {
    await axios.put(api + "/" + data.reference, data).then((response) => {
      let message = response.data.message;
      let status = response.data.status;

      dispatch("notification/store", { status, message }, { root: true });

      if (status == "success") {
        router.push({
          name: "payments-customers-index",
        });
      }
    });
  },

  async destroy({ dispatch }, reference) {
    await this.$api.delete(api + "/" + reference).then((response) => {
      let status = response.data.status;

      if (status == "success") {
        router.push({ name: "payments-customers-index" });
      }
    });
  },

  async filter({ dispatch, commit }, data) {
    await this.$api.create(api + "_filter", data).then((response) => {
      let payments = response.data;
      commit("SET_PAYMENTS", payments);
    });
  },

  async print({ dispatch }, data) {
    try {
      dispatch(
        "notification/storeDownloading",
        {
          status: "success",
          message:
            "La liste des paiements du client est en cours de téléchargement. Veuillez patienter...",
        },
        { root: true }
      );
      const response = await axios
        .post(api + "_print", data, {
          responseType: "blob", // Set the response type to 'blob' to handle binary data
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Paiements.pdf");
          link.click();
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  },

  async printReceipt({ dispatch }, reference) {
    try {
      dispatch(
        "notification/storeDownloading",
        {
          status: "success",
          message:
            "Votre reçu de paiement est en cours de téléchargement, veuillez patienter...",
        },
        { root: true }
      );
      const response = await axios
        .get(api + "_print_receipt/" + reference, {
          responseType: "blob", // Set the response type to 'blob' to handle binary data
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Recu.pdf");
          link.click();
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  },

  async fetchPaymentSupplier({ commit }) {
    await axios.get(api + "_suppliers").then((response) => {
      let payments = response.data;
      commit("SET_SUPPLIER_PAYMENTS", payments);
      window.location;
    });
  },

  async storePaymentSupplier({ dispatch }, data) {
    await this.$api.create(api + "_suppliers", data).then((response) => {
      let status = response.data.status;

      if (status == "success") {
        router.push({
          name: "payments-suppliers-index",
        });
      }
    });
  },
};

// mutations
const mutations = {
  SET_PAYMENTS(state, payments) {
    state.payments = payments;
  },
  SET_SUPPLIER_PAYMENTS(state, payments) {
    state.paymentSuppliers = payments;
  },
  setPayment(state, payment) {
    state.payment = payment;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
